export enum Action {
  Create = 'create',
  Read = 'read',
  Delete = 'delete',
}

export const ALL_ACTIONS = [Action.Create, Action.Read, Action.Delete] as const;
export const READ_ONLY_ACTIONS = [Action.Read] as const;
